import { Button, Container, Stack, Text, Title } from '@mantine/core';
import { IconExternalLink } from '@tabler/icons-react';

import { GTILogo, LogoPaper, LogoutButton } from '@/components';
import { config } from '@/config/environment';

export function BouncePage() {
  const handleRedirect = () => {
    window.location.href = config.backofficeAppUrl;
  };

  return (
    <Container size={420} my={40}>
      <LogoPaper>
        <Stack align="center" gap="lg">
          <GTILogo />
          <Title order={2} ta="center">
            Access Restricted
          </Title>

          <Text ta="center" c="dimmed">
            Thanks for checking out our new portal, but your account doesn't have access. Please use
            our main platform or get in touch with your Customer Success Manager to request access.
          </Text>

          <Button
            size="lg"
            rightSection={<IconExternalLink size={20} />}
            onClick={handleRedirect}
            fullWidth
          >
            Back to the Platform
          </Button>
          <LogoutButton />
        </Stack>
      </LogoPaper>
    </Container>
  );
}
